<div class="app-create-account" [class.welcome-message]="showWelcomeMessage()">
  @if (saving()) {
  <div class="app-create-account__loading">
    <div class="app-create-account__loading-card">
      <aprova-loading-bar title="Confirmando sua conta..." />
    </div>
  </div>
  } @else if (showWelcomeMessage()) {
  <div class="app-create-account__welcome-box">
    <div class="app-create-account__welcome-box__body">
      <span class="app-create-account__welcome-box__hand" aria-hidden="true">👋</span>

      <div class="app-create-account__welcome-box__header">
        <p class="app-create-account__welcome-box__title">
          Que bom ter você com a gente!
        </p>
        <p class="app-create-account__welcome-box__subtitle">
          Vamos iniciar o seu cadastro de <strong>conta externa</strong>,
          exclusivo para você que é <strong>requerente</strong>.
        </p>
      </div>
    </div>

    <div class="app-create-account__welcome-box__actions">
      <button
        type="button"
        class="app-create-account__btn app-create-account__btn--secondary"
        (click)="redirectToLogin()"
      >
        Voltar
      </button>
      <button
        type="button"
        class="app-create-account__btn app-create-account__btn--primary"
        (click)="startAccountCreation()"
      >
        Continuar
      </button>
    </div>

    <div class="app-create-account__welcome-box__informative">
      <aprova-icon
        name="information-circle-solid"
        size="lg"
        color="#074A4E"
        class="info-icon"
      />
      <span>
        Se você trabalha nesta organização e precisa de
        <strong>conta interna</strong>, solicite ao administrador do sistema que
        lhe envie um convite para realizar o seu cadastro. Em caso de dúvidas,
        entre em contato com o nosso suporte.
      </span>
    </div>
  </div>
  } @else if (!accountCreated()) {
  <div class="app-create-account__content">
    <h1 class="app-create-account__title">Criação de conta</h1>
    
    <aprova-stepper
      type="bullets"
      [steps]="steps"
      [currentStep]="currentStep"
      [showStepLabels]="true"
      [allowDirectNavigation]="false"
      (stepChange)="onStepChange($event)"
    />

    @switch(currentStep) { @case(0) {
    <app-personal-form
      [blockedFields]="blockedFields"
      [cityConnection]="cityConnection"
      (setStepValidation)="setStepValidation(0, $event)"
      (onValidationError)="handleValidationError($event)"
      (onValidating)="handleValidatingState($event)"
    />
    } @case (1) {
    <app-address-form
      [hideRecaptcha]="hideRecaptcha"
      [blockedFields]="blockedFields"
      [isLastStep]="hidePasswordFields"
      (setStepValidation)="setStepValidation(1, $event)"
      (changeRecaptcha)="onChangeRecaptcha($event)"
    />
    } @case(2) {
    <app-account-form
      [hideRecaptcha]="hideRecaptcha"
      [extraFields]="extraFields"
      (setStepValidation)="setStepValidation(2, $event)"
      (changeRecaptcha)="onChangeRecaptcha($event)"
    />
    } }

    <div class="app-create-account__content__actions">
      <button
        type="button"
        class="app-create-account__btn app-create-account__btn--secondary"
        (click)="goToStep(currentStep - 1)"
      >
        Voltar
      </button>
      <button
        type="button"
        class="app-create-account__btn app-create-account__btn--primary"
        [disabled]="!isCurrentStepValid || isValidatingCpfEmail()"
        (click)="goToNextStep()"
      >
        {{ currentStep === steps.length - 1 ? 'Finalizar' : 'Continuar' }}
      </button>
    </div>
  </div>
  } @else {
  <div class="app-create-account__success">
    <div class="app-create-account__success__icon">
      <aprova-icon
        name="check-circle-solid"
        size="lg"
        color="currentColor"
      />
    </div>
    <div class="app-create-account__success__content">
      <p class="app-create-account__success__title">
        Conta criada com sucesso!
      </p>
      @if (sendConfirmationEmail()) {

      <p class="app-create-account__success__subtitle">
        Enviamos um link de confirmação para o seu e-mail.<br>
        Acesse sua caixa de entrada e confirme a conta para liberar o acesso à Aprova.
      </p>
      <aprova-button
        buttonType="button"
        buttonClass="app-create-account__success__login__btn"
        label="Ir para o login"
        (click)="redirectToLogin()"
      />
      } @else {
      <p class="app-create-account__success__subtitle">
        Você será redirecionado para dentro do sistema em alguns segundos.
      </p>
      }
    </div>
  </div>
  }
</div>

<!-- Validation Error Modal -->
<aprova-validation-error-modal
  [isOpen]="showValidationErrorModal()"
  [errorData]="validationErrorData()"
  (onClose)="closeValidationErrorModal()"
  (onRetry)="retryAfterValidationError()"
/>
